import { MessageSquare, Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { TabsContent } from "@/components/ui/tabs";

export const getNoteTypeLabel = (type) => {
  const labels = {
    meeting_minutes: "Meeting Minutes",
    site_visit_notes: "Site Visit Notes",
    revision_remark: "Revision Notes",
    general_note: "General Note"
  };
  return labels[type] || type;
};

export const getNoteTypeColor = (type) => {
  const colors = {
    meeting_minutes: "bg-blue-500/20 text-blue-400",
    site_visit_notes: "bg-green-500/20 text-green-400",
    revision_remark: "bg-yellow-500/20 text-yellow-400",
    general_note: "bg-gray-500/20 text-gray-400"
  };
  return colors[type] || "bg-gray-500/20 text-gray-400";
};

export const NotesTab = ({ projectNotes, onAddNote, handleDeleteNote }) => (
  <TabsContent value="notes" className="animate-fade-in">
    <div className="bg-[#1A1A1A] border border-[#262626] rounded p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-white">Project Notes</h3>
          <p className="text-sm text-gray-500">Meeting minutes, site visit notes, revision remarks</p>
        </div>
        <Button onClick={onAddNote} className="bg-[#FF4500] hover:bg-[#E65100]" data-testid="add-note-btn">
          <Plus className="w-4 h-4 mr-2" /> Add Note
        </Button>
      </div>

      {projectNotes?.length > 0 ? (
        <div className="space-y-4">
          {projectNotes.map((note) => (
            <div key={note.note_id} className="p-4 bg-[#171717] rounded border border-[#262626] hover:border-[#333] transition-colors">
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-2">
                    <span className={`px-2 py-0.5 rounded text-xs font-medium ${getNoteTypeColor(note.note_type)}`}>
                      {getNoteTypeLabel(note.note_type)}
                    </span>
                    {note.reference && (
                      <span className="text-xs text-gray-500">Ref: {note.reference}</span>
                    )}
                  </div>
                  <h4 className="text-white font-medium mb-2">{note.title}</h4>
                  <p className="text-sm text-gray-400 whitespace-pre-wrap">{note.content}</p>
                  <div className="flex items-center gap-4 mt-3 text-xs text-gray-500">
                    <span>By {note.created_by_name || "Unknown"}</span>
                    <span>{new Date(note.created_at).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</span>
                  </div>
                </div>
                <button
                  onClick={() => handleDeleteNote(note.note_id)}
                  className="p-2 text-gray-500 hover:text-red-400 transition-colors"
                  title="Delete note"
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-12">
          <MessageSquare className="w-12 h-12 text-gray-600 mx-auto mb-4" />
          <p className="text-white font-medium mb-2">No notes yet</p>
          <p className="text-gray-500 text-sm mb-4">Add meeting minutes, site visit notes, or revision remarks</p>
          <Button onClick={onAddNote} className="bg-[#FF4500] hover:bg-[#E65100]">
            <Plus className="w-4 h-4 mr-2" /> Add First Note
          </Button>
        </div>
      )}
    </div>
  </TabsContent>
);
